import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

export default function Polygon({ children, background, onClick }) {
  return (
    <button className={styles.polygon} onClick={onClick}>
      <img src={background} className={styles.backgroundImg} alt='' />
      <div className={styles.content}>{children}</div>
    </button>
  );
}

Polygon.propTypes = {
  children: PropTypes.node,
  background: PropTypes.string,
  onClick: PropTypes.func
};
